import i18n from 'i18next';
import HttpApi from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

import { AVAILABLE_LOCALE } from './constants/i18n';

i18n
  .use(HttpApi)
  .use(initReactI18next)
  .init({
    supportedLngs: AVAILABLE_LOCALE,
    fallbackLng: 'fr',
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    backend: {
      loadPath: '/locales/{{lng}}.json',
    },
    detection: {
      lookupQuerystring: 'locale',
    },
  });

export default i18n;
